import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import R from 'ramda';

const CardsCarouselContainer = ({
  childComponent: ChildComponent,
  ...props
}) => (
  <ChildComponent
    {...props}
  />
);

const mapStateToProps = ({ content, breakpoints = {} }, { cards }) => ({
  cardsData: R.pathOr({}, ['cards', R.prop('cardsStoreDataKey')(cards)])(content),
  currentBreakpoint: breakpoints.current,
});

CardsCarouselContainer.propTypes = {
  childComponent: PropTypes.func.isRequired,
};

export default connect(mapStateToProps)(CardsCarouselContainer);
